import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle, Phone } from "lucide-react";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="border-t border-slate-200 bg-[#0B241C] text-slate-300">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:grid-cols-2 lg:grid-cols-4 lg:px-8">
      <div>
        <Logo dark />
        <p className="mt-5 max-w-xs font-display text-lg font-semibold leading-snug text-white">
          Trusted Healthcare. Delivered Responsibly.
        </p>
        <p className="mt-3 text-sm leading-relaxed text-slate-400">
          Healthcare essentials, with care at every step.
        </p>
      </div>

      <div>
        <h3 className="font-mono text-xs font-semibold tracking-[0.22em] text-emerald-400">NAVIGATE</h3>
        <ul className="mt-5 space-y-3 text-sm">
          {[
            { to: "/", label: "Home" },
            { to: "/products", label: "Products" },
            { to: "/about", label: "About Us" },
            { to: "/blog", label: "Blog" },
            { to: "/contact", label: "Contact" },
          ].map((l) => (
            <li key={l.to}>
              <Link to={l.to} data-testid={`footer-${l.label.toLowerCase().replace(/\s/g, "-")}-link`} className="transition-[color] hover:text-white">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="font-mono text-xs font-semibold tracking-[0.22em] text-emerald-400">LEGAL</h3>
        <ul className="mt-5 space-y-3 text-sm">
          {[
            { to: "/privacy-policy", label: "Privacy Policy" },
            { to: "/terms-and-conditions", label: "Terms & Conditions" },
            { to: "/return-refund-policy", label: "Return & Refund Policy" },
            { to: "/shipping-policy", label: "Shipping Policy" },
          ].map((l) => (
            <li key={l.to}>
              <Link to={l.to} data-testid={`footer-legal-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="transition-[color] hover:text-white">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="font-mono text-xs font-semibold tracking-[0.22em] text-emerald-400">CUSTOMER SUPPORT</h3>
        <a
          href="mailto:info@onecarelife.health"
          data-testid="footer-email-link"
          className="mt-5 flex items-center gap-2 text-sm font-medium text-white transition-[color] hover:text-emerald-300"
        >
          <Mail className="h-4 w-4 text-emerald-400" />
          info@onecarelife.health
        </a>
        <a
          href="tel:+17754169317"
          data-testid="footer-phone-link"
          className="mt-3 flex items-center gap-2 text-sm font-medium text-white transition-[color] hover:text-emerald-300"
        >
          <Phone className="h-4 w-4 text-emerald-400" />
          +1 (775) 416-9317
        </a>
        <a
          href="https://wa.me/918545884773"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp-link"
          className="mt-3 flex items-center gap-2 text-sm font-medium text-white transition-[color] hover:text-emerald-300"
        >
          <MessageCircle className="h-4 w-4 text-emerald-400" />
          WhatsApp: +91 85458 84773
        </a>
        <a
          href="https://www.instagram.com/onecarellife"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram-link"
          className="mt-3 flex items-center gap-2 text-sm font-medium text-white transition-[color] hover:text-emerald-300"
        >
          <Instagram className="h-4 w-4 text-emerald-400" />
          Follow us: @onecarellife
        </a>
        <p className="mt-3 text-sm text-slate-400">Support by email, phone and WhatsApp, worldwide.</p>
        <p className="mt-6 text-xs leading-relaxed text-slate-500">
          Medicines that require a prescription or other clinical authorisation are supplied only through a lawful,
          appropriately authorised process. Product availability and supply eligibility may vary by location.
        </p>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-slate-500">
      © 2026 OneCare Pharmacy · onecarelife.health
    </div>
  </footer>
);
